import {
  GET_OUTSOURCE_AUTHOR,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialProducts = {
  outSourceauthor: [],
  outSourceauthor: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

const outsourceauthorReducer = (state = initialProducts, action) => {
  switch (action.type) {
    case GET_OUTSOURCE_AUTHOR:
      return {
        ...state,
        outSourceauthor: action.payload.data.map((product) => {
          return {
            ...product,
          };
        }),
        outSourceauthorCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    default:
      return state;
  }
};

export default outsourceauthorReducer;
